/**
 * EL PASO GUIADO — la cadena de instrucción, en pantalla.
 * =============================================================================
 *
 * Se extrajo de `Riego.jsx` cuando apareció el segundo módulo, que es cuando un patrón
 * deja de ser una coincidencia. Lo comparten riego y eléctrico, y lo van a compartir
 * cámaras, iluminación, red y madera: la forma de guiar no cambia entre rubros.
 *
 * Las tres reglas de forma vienen de los principios del producto y están aquí, no en
 * cada módulo, justamente para que no puedan divergir:
 *
 *  · El instrumento va ARRIBA de los movimientos. Si no lo trae, la visita se rehace.
 *  · La teoría va detrás de un toque (Principio 8), nunca desplegada por defecto: se
 *    lee de pie y con una mano, y el que ya sabe no la necesita.
 *  · El guion de venta va como cita, con forma propia. No es lo mismo un resultado del
 *    sistema que algo que sale de tu boca, y verse igual los confundía.
 */

import { useState } from 'react'

export function Avance ({ pasos, i, onIr }) {
  return (
    <ol className="avance" aria-label="Pasos del levantamiento">
      {pasos.map((p, n) => (
        <li key={p.id}>
          <button type="button"
            className={`hito ${n === i ? 'ahora' : ''} ${n < i ? 'hecho' : ''}`}
            onClick={() => n <= i && onIr(n)} disabled={n > i}
            aria-current={n === i ? 'step' : undefined}
            aria-label={`Paso ${n + 1}: ${p.titulo}`} />
        </li>
      ))}
    </ol>
  )
}

export default function PasoGuia ({ paso }) {
  const [porQue, setPorQue] = useState(false)

  return (
    <div className="paso-guia">
      <h2 className="sec" style={{ marginTop: 0 }}>{paso.titulo}</h2>

      {paso.instrumento && (
        <p className="pastilla" style={{ marginBottom: 'var(--e4)' }}>{paso.instrumento}</p>
      )}

      <ol className="comos">
        {paso.como.map((c, n) => <li key={n}>{c}</li>)}
      </ol>

      {paso.ojo && (
        <div className="warn leible" style={{ marginTop: 'var(--e5)' }}>
          <b>Ojo:</b> {paso.ojo}
        </div>
      )}

      <button type="button" className="discreto" style={{ marginTop: 'var(--e3)' }}
        onClick={() => setPorQue(!porQue)} aria-expanded={porQue}>
        {porQue ? 'Ocultar el porqué' : '¿Por qué se hace así?'}
      </button>
      {porQue && (
        <div className="nota leible" style={{ marginTop: 'var(--e4)' }}>
          <p style={{ margin: 0 }}>{paso.porQue}</p>
        </div>
      )}

      {paso.decir && (
        <blockquote className="guion leible">
          <span>Dile al cliente</span>
          <p>{paso.decir}</p>
        </blockquote>
      )}
    </div>
  )
}
